import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "isExpanded"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import { Box } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledContent = styled(Box).withConfig({
  displayName: "Content__StyledContent",
  componentId: "sc-x8w07h-0"
})(["overflow:hidden;transition:height 0.2s ease-in-out,padding 0.2s ease-in-out;border-bottom:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.templates.colors.secondary8;
});

var Content = function Content(_ref2) {
  var children = _ref2.children,
      isExpanded = _ref2.isExpanded,
      props = _objectWithoutProperties(_ref2, _excluded);

  var contentEl = useRef(null);
  useLayoutEffect(function () {
    var current = contentEl.current;

    if (current) {
      var contentHeight = "".concat(current.scrollHeight, "px");

      if (isExpanded) {
        requestAnimationFrame(function () {
          current.style.height = '0';
          requestAnimationFrame(function () {
            current.style.height = contentHeight;
          });
        });
      } else {
        requestAnimationFrame(function () {
          current.style.height = '0';
        });
      }
    }
  }, [isExpanded]);
  return /*#__PURE__*/_jsx(StyledContent, _objectSpread(_objectSpread({
    ref: contentEl
  }, props), {}, {
    children: children
  }));
};

export default Content;